/**
 * OZONE — PDP description "Leggi di più" / "Mostra meno"
 * Mostra il toggle solo se il contenuto supera davvero l'altezza collassata.
 */
(function () {
  var COLLAPSE_ATTR = 'data-collapse-px';
  var INIT_ATTR = 'data-eoo-desc-ready';

  function measureFullHeight(inner) {
    var prevMax = inner.style.maxHeight;
    var prevOverflow = inner.style.overflow;
    inner.style.maxHeight = 'none';
    inner.style.overflow = 'visible';
    var full = Math.ceil(inner.getBoundingClientRect().height || inner.scrollHeight);
    inner.style.maxHeight = prevMax;
    inner.style.overflow = prevOverflow;
    return full;
  }

  function init(root) {
    if (root.getAttribute(INIT_ATTR) === '1') return;
    root.setAttribute(INIT_ATTR, '1');

    var inner = root.querySelector('[data-eoo-desc-inner]');
    var btn = root.querySelector('[data-eoo-desc-toggle]');
    if (!inner || !btn) return;

    var more = btn.querySelector('[data-eoo-desc-more]');
    var less = btn.querySelector('[data-eoo-desc-less]');
    var collapsedMax = parseInt(root.getAttribute(COLLAPSE_ATTR) || '140', 10);
    // Piccolo buffer per evitare toggle su 1-2px di differenza
    var threshold = collapsedMax + 8;

    function needsToggle() {
      var full = measureFullHeight(inner);
      return full > threshold;
    }

    function applyCollapsedUi(open) {
      if (open) {
        root.classList.add('is-open');
      } else {
        root.classList.remove('is-open');
      }
      if (more) more.hidden = open;
      if (less) less.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function sync() {
      if (!needsToggle()) {
        root.classList.add('is-open');
        root.classList.add('eoo-desc--no-toggle');
        root.classList.remove('eoo-desc--needs-toggle');
        btn.hidden = true;
        btn.setAttribute('aria-hidden', 'true');
        return;
      }

      root.classList.remove('eoo-desc--no-toggle');
      root.classList.add('eoo-desc--needs-toggle');
      btn.hidden = false;
      btn.removeAttribute('aria-hidden');
      applyCollapsedUi(root.classList.contains('is-open'));
    }

    btn.addEventListener('click', function () {
      applyCollapsedUi(!root.classList.contains('is-open'));
    });

    // Misura dopo layout/font (evita falsi positivi a load)
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(sync).catch(sync);
    } else {
      sync();
    }
    requestAnimationFrame(sync);

    var resizeTimer;
    window.addEventListener(
      'resize',
      function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(sync, 150);
      },
      { passive: true }
    );
  }

  function boot() {
    document.querySelectorAll('[data-eoo-desc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
